import { MultiSelect, MultiSelectProps } from 'primereact/multiselect';
import React from 'react';

interface PrimeReactMultiSelectProps extends MultiSelectProps {
  // You can add additional custom props here if needed
}

const PrimeReactMultiSelect: React.FC<PrimeReactMultiSelectProps> = (props) => {
  return <MultiSelect {...props} />;
};

export default PrimeReactMultiSelect;
